"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snackbar = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_router_dom_1 = require("react-router-dom");
var timer_1 = require("remota-client/hook/timer");
var CloseIcon_1 = __importDefault(require("remota-client/component/atoms/icons/CloseIcon"));
var IconButton_1 = __importDefault(require("remota-client/component/molecules/IconButton"));
var nop = function () { };
exports.Snackbar = react_1.default.memo(function (props) {
    var message = props.message, drop = props.drop;
    // const callbackRef = React.useRef<number | null>(null)
    var close = react_1.default.useCallback(function () { return drop(message.id); }, [message.id, drop]);
    (0, timer_1.useTimer)(close, message.displayMillisec);
    var location = (0, react_router_dom_1.useLocation)();
    var handleClick = react_1.default.useCallback(function () {
        if (message.onClick) {
            message.onClick();
            close();
        }
    }, [close, message]);
    var isShow = react_1.default.useMemo(function () {
        var urlCondition = message.urlCondition;
        if (!urlCondition) {
            return true;
        }
        var url = location.pathname;
        if (typeof urlCondition === "string") {
            return urlCondition === url;
        }
        else if (typeof urlCondition === "function") {
            return urlCondition(url);
        }
        else {
            return urlCondition.test(url);
        }
    }, [location.pathname, message]);
    if (!isShow) {
        return null;
    }
    return (react_1.default.createElement(Root, { "data-testid": "Snackbar", "data-severity": message.severity, severity: message.severity, onClick: handleClick, clickable: !!message.onClick },
        react_1.default.createElement(FlexBox, null,
            react_1.default.createElement(FlexChild, null,
                react_1.default.createElement(Clamp, null, message.message)),
            react_1.default.createElement(FlexChild, null,
                react_1.default.createElement(IconButton_1.default, { style: { margin: "-2px 0 0 16px", padding: "0" }, icon: react_1.default.createElement(CloseIcon_1.default, { size: "small" }), disabled: false, onClick: function (e) {
                        // prevent links to be followed.
                        e.preventDefault();
                        e.stopPropagation();
                        (close || nop)();
                        return false;
                    } })))));
});
var LEFT_PADDING = 16;
var MIN_WIDTH = 280;
var CLOSE_BUTTON_HORIZONTAL_SPACE = 48; //16 * 3;
var TEXT_MIN_SPACE = MIN_WIDTH - LEFT_PADDING - CLOSE_BUTTON_HORIZONTAL_SPACE;
var FlexBox = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  padding-bottom: 0;\n  padding-top: 2px;\n"], ["\n  display: flex;\n  padding-bottom: 0;\n  padding-top: 2px;\n"])));
var Clamp = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: -webkit-inline-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-width: ", "px;\n"], ["\n  display: -webkit-inline-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-width: ", "px;\n"])), TEXT_MIN_SPACE);
var FlexChild = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""
    // PADDING TOP to center align close button for one single line is (MIN_HEIGHT - ICON_SIZE) /2 = (40 - 16)/2 = 12px
])));
// PADDING TOP to center align close button for one single line is (MIN_HEIGHT - ICON_SIZE) /2 = (40 - 16)/2 = 12px
var Root = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n\n  position: fixed;\n\n  top: 16px;\n  left: 16px;\n\n  min-height: 40px;\n  min-width: ", "px;\n  max-width: 720px;\n  padding: 12px 16px 0 16px;\n\n  border-radius: ", ";\n  box-sizing: border-box;\n\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.24);\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  background: ", ";\n  color: ", ";\n  &:hover {\n    cursor: ", ";\n  }\n  text-decoration: ", ";\n  z-index: 1000;\n"], ["\n  display: inline-block;\n\n  position: fixed;\n\n  top: 16px;\n  left: 16px;\n\n  min-height: 40px;\n  min-width: ", "px;\n  max-width: 720px;\n  padding: 12px 16px 0 16px;\n\n  border-radius: ", ";\n  box-sizing: border-box;\n\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.24);\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 12px;\n  background: ", ";\n  color: ", ";\n  &:hover {\n    cursor: ", ";\n  }\n  text-decoration: ", ";\n  z-index: 1000;\n"])), MIN_WIDTH, function (props) { return props.theme.borderRadius.all; }, function (props) {
    switch (props.severity) {
        case "error":
            return props.theme.colors.red2;
        case "warning":
            return props.theme.colors.warn;
        case "info":
            return props.theme.colors.tableBlack1;
        case "success":
            return props.theme.colors.green;
        case "default":
            return props.theme.colors.tableBlack1;
    }
}, function (props) { return props.theme.colors.white; }, function (props) { return (props.clickable ? "pointer" : undefined); }, function (props) { return (props.clickable ? "underline" : undefined); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
